var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t, I18NLink } from "../../I18N";
import SafeHTML from "../../utils/SafeHTML";
import getFieldLabel from "../../Templates/utils/getFieldLabel";
import Immutable from 'immutable';

export const MetadataFieldSnippets = ({ fieldSnippets, documentViewUrl, template, searchTerm }) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx("li", { className: "snippet-list-item-header metadata-snippet-header" }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: `${documentViewUrl}?searchTerm=${searchTerm}` }, void 0,
getFieldLabel(fieldSnippets.get('field'), template))),


fieldSnippets.get('texts').map((snippet, index) => /*#__PURE__*/
_jsx("li", { className: "snippet-list-item metadata-snippet" }, index, /*#__PURE__*/
_jsx("span", {}, void 0, /*#__PURE__*/
_jsx(SafeHTML, {}, void 0, snippet)))));






MetadataFieldSnippets.defaultProps = {
  searchTerm: ''
};










MetadataFieldSnippets.defaultProps = {
  template: undefined
};

export const DocumentContentSnippets = ({
  selectSnippet,
  documentSnippets,
  documentViewUrl,
  searchTerm,
  selectedSnippet
}) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx("li", { className: "snippet-list-item-header fulltext-snippet-header" }, void 0,
t('System', 'Document contents')),

documentSnippets.map((snippet, index) => {
  const selected = snippet.get('text') === selectedSnippet.get('text') ? 'selected' : '';
  return /*#__PURE__*/(
    _jsx("li", { className: `snippet-list-item fulltext-snippet ${selected}` }, index, /*#__PURE__*/
    _jsx(I18NLink, {
      onClick: () => selectSnippet(snippet.get('page'), snippet),
      to: `${documentViewUrl}?page=${snippet.get('page')}&searchTerm=${searchTerm || ''}` }, void 0, /*#__PURE__*/

    _jsx("span", { className: "page-number" }, void 0, snippet.get('page')), /*#__PURE__*/
    _jsx("span", { className: "snippet-text" }, void 0, /*#__PURE__*/
    _jsx(SafeHTML, {}, void 0, snippet.get('text'))))));




}));















export const SnippetList = ({
  snippets,
  documentViewUrl,
  searchTerm,
  selectSnippet,
  template,
  selectedSnippet
}) => /*#__PURE__*/
_jsx("ul", { className: "snippet-list" }, void 0,
snippets.get('metadata').map((fieldSnippets) => /*#__PURE__*/
_jsx(MetadataFieldSnippets, {

  fieldSnippets: fieldSnippets,
  template: template,
  documentViewUrl: documentViewUrl,
  searchTerm: searchTerm }, fieldSnippets.get('field'))),


snippets.get('fullText').size ? /*#__PURE__*/
_jsx(DocumentContentSnippets, {
  documentSnippets: snippets.get('fullText'),
  documentViewUrl: documentViewUrl,
  selectSnippet: selectSnippet,
  selectedSnippet: selectedSnippet,
  searchTerm: searchTerm }) :


'');



















SnippetList.defaultProps = {
  template: undefined
};

export const mapStateToProps = (state, ownProps) => ({
  template: state.templates.find((tmpl) => tmpl.get('_id') === ownProps.doc.get('template')),
  selectedSnippet: state.documentViewer.uiState.get('snippet')
});

export default connect(mapStateToProps)(SnippetList);